import { render, staticRenderFns } from "./PermitDetails.vue?vue&type=template&id=0939ec83"
import script from "./PermitDetails.vue?vue&type=script&lang=js"
export * from "./PermitDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports